// extracted by mini-css-extract-plugin
export default {"howTo":"howTo__3_BAX","bookerShown":"bookerShown__2XoL4","howToTitle":"howToTitle__3EGEO","howToStep":"howToStep__lqIr8","howToNumber":"howToNumber__1vPBo","howToText":"howToText__1v9gH"};
    if(module.hot) {
      // 1790586299214
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  